import React from 'react';
import { FaCheckCircle, FaHome } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const ThankYouPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {/* Success Icon */}
        <div className="mb-6 flex justify-center">
          <div className="w-24 h-24 bg-gradient-to-r from-green-400 to-blue-500 rounded-full flex items-center justify-center">
            <FaCheckCircle className="text-white text-5xl" />
          </div>
        </div>

        {/* Thank You Message */}
        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          Thank You!
        </h1>
        <p className="text-gray-600 text-lg mb-8">
          Your message has been received. We will get back to you soon.
        </p>

        {/* Return Home Button */}
        <Link
          to="/"
          className="inline-flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition"
        >
          <FaHome className="mr-2" />
          Return to Homepage
        </Link>

        {/* Optional Additional Info */}
        <div className="mt-8 text-sm text-gray-500">
          <p>Our team typically responds within 24 hours.</p>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;